import { Button, Meta, theme } from 'aimo-ui';
import React from 'react';
import { useTranslation } from 'react-i18next';
import { StyledWrapper } from 'styles/ContainerStyles';
import { useUiStore } from 'stores/uiStore';

const AccountRemovalFailed = () => {
  const { t } = useTranslation();
  return (
    <StyledWrapper mb={0}>
      <StyledWrapper center>
        <Meta center testID="remove-failed-text" color={theme.colors.gray300}>
          {t('account.removeFailedText')}
        </Meta>
      </StyledWrapper>
      <StyledWrapper mb={0}>
        <Button
          testID="close-button"
          size="l"
          text={t('button.close')}
          onPress={() => useUiStore.getState().setSheetModal('')}
        />
      </StyledWrapper>
    </StyledWrapper>
  );
};

export default AccountRemovalFailed;
